import {
  environment,
  raygunIsEnabled,
  version,
  raygunApiKey
} from 'src/config';

let logErrorToRaygun = ({ error }) => {
  console.error("Raygun disabled, but here's your error", error); // eslint-disable-line no-console
};

const platform = ENV.CLIENT ? 'client' : 'server';

const tags = [`environment:${environment}`, `platform:${platform}`];

if (raygunIsEnabled) {
  if (ENV.CLIENT) {
    const logErrorToRaygunClient = require('raygun4js');
    logErrorToRaygunClient('apiKey', raygunApiKey);
    logErrorToRaygunClient('enableCrashReporting', true);
    logErrorToRaygunClient('options', {
      ignoreAjaxAbort: true,
      ignore3rdPartyErrors: true
    });
    logErrorToRaygunClient('whitelistCrossOriginDomains', ['seekcdn.com']);
    logErrorToRaygunClient('setVersion', version);
    logErrorToRaygunClient('withTags', tags);

    logErrorToRaygun = ({ error, customData }) =>
      logErrorToRaygunClient('send', { error, customData });
  } else {
    const raygun = require('raygun');
    const logErrorToRaygunServerClient = new raygun.Client()
      .init({ apiKey: raygunApiKey })
      .setVersion(version);

    logErrorToRaygun = ({ error, req, customData }) => {
      if (error) {
        logErrorToRaygunServerClient.send(
          error,
          customData,
          () => {}, // Response handler
          req, // Request data
          tags // Tags
        );
      }
    };
  }
}

export { logErrorToRaygun };
